export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NewsListingItem.vue?vue&type=template&id=33459b24&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/NewsListingItem.vue?vue&type=template&id=33459b24&scoped=true&
// module id = 310
// module chunks = 0